module.exports = __webpack_public_path__ + "img/5.de3674be.png";